// plugins/utm.js — сквозной перенос UTM-меток (ТЗ: метки из рассылок/рекламы не должны теряться
// на переходах и оплате — для атрибуции заказов в Яндекс.Метрике).
// Метки живут в sessionStorage (текущая сессия), перезапись — last-touch.
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const STORAGE_KEY = "pps_utm";

function readStored() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) {
        return {};
    }
}

function writeStored(values) {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(values));
    } catch (e) {
        /* приватный режим — молча игнорируем */
    }
}

export default ({ app }, inject) => {
    if (process.server) return;

    // 1. Захват меток первого попадания (last-touch: новые перезаписывают сохранённые)
    const stored = readStored();
    const query = app.context.route.query;
    let captured = false;
    UTM_KEYS.forEach((key) => {
        const value = query[key];
        if (value !== undefined && value !== "") {
            stored[key] = Array.isArray(value) ? String(value[0]) : String(value);
            captured = true;
        }
    });
    if (captured) {
        writeStored(stored);
    }

    inject("utm", {
        // Сохранённые метки (объект)
        get() {
            return readStored();
        },
        // Добавляет сохранённые метки к адресу, если их там ещё нет
        // (для history.pushState/replaceState, которые минуют vue-router)
        url(target) {
            try {
                const values = readStored();
                if (!UTM_KEYS.some((key) => values[key])) return target;
                let path;
                let rawQuery = "";
                if (String(target).indexOf("?") === 0) {
                    // относительный адрес вида "?q=..." — путь берём из текущей строки браузера
                    path = window.location.pathname;
                    rawQuery = String(target).substring(1);
                } else {
                    const parts = String(target).split("?");
                    path = parts[0];
                    rawQuery = parts[1] || "";
                }
                const params = new URLSearchParams(rawQuery);
                let changed = false;
                UTM_KEYS.forEach((key) => {
                    if (values[key] && !params.has(key)) {
                        params.set(key, values[key]);
                        changed = true;
                    }
                });
                if (!changed) return target;
                const qs = params.toString();
                return path + (qs ? "?" + qs : "");
            } catch (e) {
                return target;
            }
        },
    });

    // 2. Программная SPA-навигация: мержим сохранённые метки в query каждого перехода
    //    поверх существующих параметров; если в to уже есть свои UTM — не трогаем.
    //    Без replace: редирект в guard не создаёт лишней записи истории (первый push
    //    не успевает вызвать pushState), а replace затёр бы текущую страницу из истории.
    //    Зацикливания «назад» нет: метки захватываются при полной загрузке, поэтому
    //    все записи истории этой сессии уже содержат UTM в query.
    app.router.beforeEach((to, from, next) => {
        try {
            // initial-навигация (полная загрузка): адрес чинится патчем в afterEach, без редиректа
            if (from.matched.length === 0) {
                return next();
            }
            const values = readStored();
            if (UTM_KEYS.some((key) => values[key]) && !UTM_KEYS.some((key) => to.query[key] !== undefined)) {
                const merged = Object.assign({}, to.query);
                UTM_KEYS.forEach((key) => {
                    if (values[key]) merged[key] = values[key];
                });
                return next({ path: to.path, hash: to.hash, query: merged });
            }
        } catch (e) {
            /* не блокируем навигацию */
        }
        next();
    });

    // 3. Восстановление меток в адресную строку при полной загрузке без них
    //    (возврат с внешнего эквайринга / ссылка без меток в той же сессии) —
    //    без редиректа, чтобы не было повторного монтирования страницы.
    app.router.afterEach((to, from) => {
        try {
            if (from.matched.length !== 0) return;
            const values = readStored();
            if (!UTM_KEYS.some((key) => values[key])) return;
            if (UTM_KEYS.some((key) => to.query[key] !== undefined)) return;
            const params = new URLSearchParams(window.location.search);
            let changed = false;
            UTM_KEYS.forEach((key) => {
                if (values[key] && !params.has(key)) {
                    params.set(key, values[key]);
                    changed = true;
                }
            });
            if (changed) {
                const qs = params.toString();
                window.history.replaceState(
                    null,
                    "",
                    window.location.pathname + (qs ? "?" + qs : "") + window.location.hash
                );
            }
        } catch (e) {
            /* не критично */
        }
    });
};